/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.5.0",
    versionName: "0.5.0",
    versionChannel: "stable",
    buildDate: "2026-08-03T22:27:09.537Z",
    commitHash: "a4f5b5256e245693bc9077ef6c6b6abc95490e7f",
};
